var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/core-js/library/modules/$.cof.js
// module id = 499
// module chunks = 2